import { Box, Heading, Text } from '@chakra-ui/react';
import { isRouteErrorResponse, useRouteError } from 'react-router';

const ErrorPage = () => {
	const error = useRouteError();

	return (
		<Box as="section" color="fg.muted" textAlign="center" p={8}>
			<Heading>Oops</Heading>
			<Text fontSize="2xl" fontWeight="bold" mt={4}>
				{!isRouteErrorResponse(error)
					? 'An unexpected error has occurred. Please try again later or contact support if the issue persists.'
					: 'Invalid Page'}
			</Text>
		</Box>
	);
};

export default ErrorPage;
